import bootbox from "bootbox";
import './signaturepag';
import './signature_pad_json';

$(document).ready(function(e){

    $(document).on('click', '.upload-image', function(e){
        let id = $(this).attr('data-field-id');
        $(`#${id}-image`).trigger('click');
    });

    $(document).on('click', '.upload-signature', function(e){
        e.preventDefault();
        let id = $(this).attr('data-field-id');
        $('#Signature_modal').modal('show').attr('data-field-id', id);
        $('#Signature_modal').attr('data-source', 'edit_create');
    });

    $(document).on('click', '.clear-signature', function(e){
        e.preventDefault();
        let $signature_modal = $('#Signature_modal'),
            id = $signature_modal.attr('data-field-id');
        $(`#${id}-signature`).val('cleared');
        let $image_holder=  $(`.image-holder[data-id=${id}]`),
            source = $signature_modal.attr('data-source');

        if(source === 'create_edit'){
            $image_holder.find('img').attr('src', '/images/fields/not_signed.png');
        }else if(source === 'related_section'){
            let $cell = $(`#${id}`);
            $cell.attr('data-value', 'cleared');
            $cell.addClass('update');
            $cell.find('.signature-image').attr('src', '/images/fields/not_signed.png');
            $signature_modal.modal('hide');
        }
    });

    $('#Signature_modal').on('show.bs.modal', function(e){
        setTimeout(function(){
            var canvasResize = document.getElementById("canvas_pad_custom");
            var parentWidth = $('#canvas_pad_custom').parent().outerWidth();
            canvasResize.setAttribute("width", parentWidth);
            $('.sigPad').signaturePad({
                drawOnly:true,
                lineWidth: 0,
                class: 'img-responsive',
                clear: 'button[type=button]',
                output : '.output'
            });
        },500)
    });

    $(".save-signature").on("click", function(e){
        e.preventDefault();
        let canvas = document.getElementById('canvas_pad_custom');
        let signatureDataURL = canvas.toDataURL(),
            $signature_modal = $('#Signature_modal'),
            id = $signature_modal.attr('data-field-id'),
            $image_holder=  $(`.image-holder[data-id=${id}]`),
            source = $signature_modal.attr('data-source');

        if(source === 'edit_create'){
            $(`#${id}-signature`).val(signatureDataURL);
            $(`.remove-signature[data-field-id="${id}"`).removeClass('d-none');
            $image_holder.find('img').attr('src', '/images/fields/signed.png');
            $signature_modal.modal('hide');
        }else if(source === 'related_section'){
            let $cell = $(`#${id}`);
            $cell.attr('data-value', signatureDataURL);
            $cell.addClass('update');
            $cell.find('.signature-image').attr('src', '/images/fields/signed.png');
            $signature_modal.modal('hide');
        }
    });

    $(document).on('click', '.remove-signature', function(e){
        e.preventDefault();
        let id = $(this).attr('data-field-id');
        let $image_holder=  $(`.image-holder[data-id=${id}]`);
        $image_holder.find('img').attr('src', '/images/fields/not_signed.png');
        $(`#${id}-signature`).val('cleared').attr('value', 'cleared');
        $(this).addClass('d-none');
    })

    $(document).on('click', '[data-toggle="lightbox"]', function(event) {
        event.preventDefault();
        $(this).ekkoLightbox();
    });

    $(document).on('click', '.remove-upload', function(e){
        let field_id = $(this).attr('data-field-id'),
            type = $(this).attr('data-type'),
            table = $(this).attr('data-table-id'),
            record = $(this).attr('data-record-id');

        if((type === 'edit' || type === 'browse') && $(this).hasClass('has-image')){
            bootbox.confirm("Are you sure you want to delete image?", (result) => {
                if (result) {
                    $.ajax({
                        type: 'DELETE',
                        url: '/upload',
                        data: {
                            field_id,
                            table,
                            record
                        },
                        success: (res) => {
                            if(res){
                                if(type === 'edit'){
                                    $(`#${field_id}-image`).val('').trigger('change');
                                    $(this).removeClass('has-image');
                                }else if(type === 'browse'){
                                    let $td = $(this).closest('.image-td');
                                    $td.find('img, span').remove();
                                    $(this).remove();
                                }
                            }
                        }
                    });
                }
            });
        }else{
            $(`#${field_id}-image`).val('').trigger('change');
        }
    });

    $(document).on('change', '.record-image', function(e){
        let id = $(this).attr('data-field-id');
        readURLImage(this, $(`#${id}-image-target`));
    });

    function readURLImage(input, $image){

        let $image_holder = $($image).parents('.image-holder'),
            $default_image = $($image_holder).find('.default-image'),
            $image_controls = $($image).parents('.image-controls'),
            $remove_icon = $image_controls.find('.remove-upload'),
            $image_anchor = $image.parents('.image-anchor');

        if (input.files && input.files[0]) {
            let reader = new FileReader();

            reader.onload = function (e) {
                $($image).attr('src', e.target.result).removeClass('d-none');
                $($image_anchor).attr('href', e.target.result);
                $default_image.addClass('d-none');
                $($image).parents('.image-controls').find('.remove-upload').removeClass('d-none');
            }
            reader.readAsDataURL(input.files[0]);
        }else{
            $($image).attr('src', '').addClass('d-none');
            $default_image.removeClass('d-none');
            $remove_icon.addClass('d-none');
        }
    }
});